import React from "react";

/**
 * Pass-through auth wrapper.
 * Profile completion is suggested once after login in Callback only.
 * Never force complete-profile when navigating (Create Campaign must stay open).
 */
function Authentication({ children }) {
  return <>{children}</>;
}

export default Authentication;
